import React, { useEffect } from 'react';
import { QuestionProps, ModuleProps } from 'global/types';
import { applyKatexWrap, flattenKatexUnderlines } from 'global/katexWrap';
import 'katex/dist/katex.min.css';
import renderMathInElement from 'katex/dist/contrib/auto-render.js';

import './index.css';

type TableGridProps = {
    question: QuestionProps;
    modules: ModuleProps[];
    currentModule: ModuleProps;
    autoSave: (modules: ModuleProps[]) => void;
    setModules: (modules: ModuleProps[]) => void;
};

function TableGrid({ question, modules, currentModule, autoSave, setModules } : TableGridProps) {
    const answer = currentModule.answers.find(answer => answer.questionNum === question.questionNum);

    const selectTableGridAnswer = (row: string, column: string) => {
        const updatedModules = modules.map((module) => {
            if (module.id !== currentModule.id) return module;

            const updatedAnswers = module.answers.map((item) => {
                if (item.questionNum === question.questionNum) {
                    let answer = item.answer;
                    if (Array.isArray(answer)) {
                        if (answer.find(entry => entry[0] === row && entry[1] === column)) {
                            answer = answer.filter(entry => entry[0] !== row || entry[1] !== column);
                        }
                        else {
                            answer.push([row, column]);
                        }
                    }

                    return {
                        ...item,
                        answer: answer
                    };
                }
                return item;
            });

            return {
                ...module,
                answers: updatedAnswers,
            };
        });
        autoSave(updatedModules);
        setModules(updatedModules);
    }

    const renderKatex = () => {
        const katex = document.getElementsByClassName('katex');
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ],
                trust: true
            });

            katex[i].innerHTML = katex[i].innerHTML.replaceAll('&nbsp;', ' ');
        }

        applyKatexWrap(document, {
            enabled: currentModule?.subject === 'English Language Arts',
        });

        flattenKatexUnderlines(document);

        const math = document.querySelectorAll('.katex-mathml');
        for (let i = 0; i < math.length; i++) {
            math[i].remove();
        }
    }

    useEffect(() => {
        renderKatex();
    }, [question]);

    return (
        <table className='digitalSHSATModule__tableGrid'>
            <tbody>
                <tr>
                    <th></th>
                    {question.tableGridColumns.map(column => (
                        <th key={`c${column.id}`}><p className='katex'>{column.name}</p></th>
                    ))}
                </tr>
                {question.tableGridRows.map(row => (
                    <tr key={`r${row.id}`}>
                        <th><p className='katex'>{row.name}</p></th>
                        {question.tableGridColumns.map(column => (
                            <td key={`r${row.id}c${column.id}`}>
                                <input
                                    type='checkbox'
                                    checked={(Array.isArray(answer?.answer) && answer?.answer.find(item => (
                                        item[0] === row.id && item[1] === column.id
                                    ))) ? true: false}
                                    onChange={() => selectTableGridAnswer(row.id, column.id)}
                                />
                            </td>
                        ))}
                    </tr>    
                ))}
            </tbody>
        </table>
    );
}

export default TableGrid;